export default "__VITE_ASSET__CAjhmL4M__"